// extracted by mini-css-extract-plugin
module.exports = {"FundingWalletDetails":"repaymentschedule_FundingWalletDetails__3DnKu"};